export var From;
(function (From) {
    From["Top"] = "top";
    From["Bottom"] = "bottom";
})(From || (From = {}));
export var Alignment;
(function (Alignment) {
    Alignment["Top"] = "top";
    Alignment["Center"] = "center";
    Alignment["Bottom"] = "bottom";
    Alignment["Entire"] = "entire";
    Alignment["Partial"] = "partial";
})(Alignment || (Alignment = {}));
export var ZoneUnit;
(function (ZoneUnit) {
    ZoneUnit["Millimeters"] = "millimeters";
    ZoneUnit["Percent"] = "percent";
})(ZoneUnit || (ZoneUnit = {}));
